var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.245,
    height: 15.245,
    viewBox: "0 0 15.245 15.245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "businessman",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2784",
    "data-name": "Group 2784",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2783",
    "data-name": "Group 2783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M346.053,423.27a.6.6,0,1,0-1.166.243.622.622,0,0,1-.126.522.605.605,0,0,1-.476.226H341.6a.6.6,0,1,0,0,1.191h2.689a1.809,1.809,0,0,0,1.769-2.182Z",
    transform: "translate(-330.846 -410.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M8.228,8.122A6.551,6.551,0,0,1,13.072,11a.6.6,0,1,0,.989-.663,7.746,7.746,0,0,0-4.014-3.049,4.05,4.05,0,1,0-4.847,0A7.744,7.744,0,0,0,.039,13.063a1.809,1.809,0,0,0,1.769,2.182h2.6a.6.6,0,1,0,0-1.191h-2.6a.605.605,0,0,1-.476-.226.622.622,0,0,1-.126-.522A6.582,6.582,0,0,1,6.957,8.129L5.82,13.3a.6.6,0,0,0,.161.549l1.191,1.191a.6.6,0,0,0,.842,0L9.205,13.85a.6.6,0,0,0,.161-.549ZM4.765,4.05a2.858,2.858,0,1,1,3,2.855H7.623l-.139,0A2.862,2.862,0,0,1,4.765,4.05Zm2.829,9.728-.539-.54.539-2.454.539,2.454Z",
    transform: "translate(0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessman);
export default __webpack_public_path__ + "static/media/businessman.9570425c9114cae4dc5af82760189394.svg";
export { ForwardRef as ReactComponent };